import { useEffect, useState } from 'react';

/**
 * Tracks a CSS media query from JavaScript.
 *
 * Used by AppLayout to render one layout instead of rendering the whole app
 * twice and hiding one copy with CSS.
 *
 * @param {string} query - e.g. '(min-width: 1024px)'
 */
const useMediaQuery = (query) => {
	const [matches, setMatches] = useState(
		() => window.matchMedia(query).matches
	);

	useEffect(() => {
		const list = window.matchMedia(query);
		const update = (event) => setMatches(event.matches);
		setMatches(list.matches);
		list.addEventListener('change', update);
		return () => list.removeEventListener('change', update);
	}, [query]);

	return matches;
};

export default useMediaQuery;
